import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'
import { getUserSessionState } from '../../../selectors/user'

import { fetchUsers, loadMoreUsersList } from '../../../actions'
import { get } from 'lodash'

import ManageAgency from '../../../components/pages/ManageAgency/ManageAgency'

const mapStateToProps = (state: RootState) => {
  return {
    loading: getAppLoading(state),
    userSession: getUserSessionState(state),
    usersList: state.users.users,
    loadMore: get(state, 'users.users.loading', false),
  }
}

export default connect(mapStateToProps, { fetchUsers: fetchUsers, loadMoreUsersList: loadMoreUsersList })(ManageAgency)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/ManageAgency/ManageAgency.tsx